"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
/**
 * Wrap `<FormButton>` and other action buttons into `<FormActions>` component
 * to position them accordingly and move them away from the fields above.
 */
const FormActions = ({ align = 'right', children }) => {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.root, style: { justifyContent: align === 'left'
                ? 'flex-start'
                : align === 'right'
                    ? 'flex-end'
                    : 'center',
        } }, children));
};
const useStyles = (0, react_jss_1.createUseStyles)((theme) => ({
    root: {
        marginTop: theme.sizes.formActionsDistance,
        lineHeight: 'normal',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        margin: -10,
        '& > *': {
            margin: 10,
        },
    },
}));
exports.default = FormActions;
